import type { GetProductsReqParams } from './product'
import type { EatigoMemberInfoData, EdbMemberAuthType } from '@/types/api'

export enum Gender {
  UNSPECIFIED = -1,
  FEMALE,
  MALE,
  OTHER,
  /** @deprecated Use `OTHER` instead. */
  NOT_SPECIFIED,
}

export enum MembershipLevel {
  SEEKER,
  PRO,
  ELITE,
}

export enum MemberForm {
  NAME = 'name',
  EMAIL = 'email',
  SEX = 'sex',
  BIRTHDAY = 'birthday',
}

export type MemberFormItem = {
  title: keyof EatigoMemberInfoData
  titleText: string
  placeholder?: string
  memberComponent?: Component
  importantNote?: string
  note?: string
  isEditable?: boolean
  isOptional?: boolean
  isNeedComplete?: boolean
  attributes?: Record<string, unknown>
  getFeedback?: (args: { isFocusedAndReachedLimit: boolean }) => string | undefined
  getValueText?: (value?: Nullable<string | number>) => string | undefined
}

export type MemberSettingItem = {
  type:
    | 'uid'
    | EdbMemberAuthType.MemberAuthTypeEmail
    | EdbMemberAuthType.MemberAuthTypeGoogle
    | EdbMemberAuthType.MemberAuthTypeFB
    | EdbMemberAuthType.MemberAuthTypeApple
  title: string
  show: boolean
  content?: Nullable<string>
}

export const genderI18nKeyMap = {
  [Gender.UNSPECIFIED]: 'member.profile.unfilled',
  [Gender.FEMALE]: 'member.profile.gender.female',
  [Gender.MALE]: 'member.profile.gender.male',
  [Gender.OTHER]: 'member.profile.gender.other',
}

export enum MemberEditStatus {
  UN_EDITED,
  EDITING,
  OTHER_FIELD_EDITING,
}

export interface GetCollectionsReqParams extends Pick<
  Partial<GetProductsReqParams>,
  | 'category_filter_ids'
  | 'currency_id'
  | 'starttime'
  | 'endtime'
  | 'filter_regionid'
  | 'filter_time'
  | 'max_price'
  | 'min_price'
  | 'max_branch_rating'
  | 'min_branch_rating'
  | 'size'
> {
  next_page_token?: string
}

export interface GetFavoritesReqParams extends GetCollectionsReqParams, Pick<Partial<GetProductsReqParams>, 'start' | 'lat' | 'lng'> {
  next_page_token?: string
}

export enum ActionTypeEnum {
  NONE,
  API,
  IN_APP,
  LINK,
}

type Reward = {
  isLocked: boolean
  levelName: 'seeker' | 'pro' | 'elite'
  description: string
  actionType: ActionTypeEnum
  actionText: string
  disabledActionText: string
  actionEndpoint: string
  isClaimed: boolean
}

export type IntroduceSectionContentList = {
  image: string
  title: string
  description: string
  actionType: ActionTypeEnum
  actionText?: string
  actionEndpoint?: string
  rewards?: Reward[]
}
